import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "config";
import { RootState } from "store/rootReducer";
import { StoreReviewInitialState } from "./types";

const initialState: StoreReviewInitialState = {
  isLoading: false,
  reviews: [],
};

const storeReviews = createSlice({
  name: "storeReviews",
  initialState,
  reducers: {
    setStoreReviews(state, action) {
      state.reviews = action.payload;
      state.isLoading = false;
    },
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
  },
});

export const { setStoreReviews, setIsLoading } = storeReviews.actions;

export const selectStoreReviews = (state: RootState) =>
  state.storeReviews.reviews;
export const selectStoreReviewsLoading = (state: RootState) =>
  state.storeReviews.isLoading;

export const fetchStoreReviews = () => async (dispatch: any) => {
  dispatch(setIsLoading(true));
  try {
    const fetchURL = `${API_URL}/comments`;
    const { data } = await axios.get(fetchURL);

    dispatch(setStoreReviews(data.data));
  } catch (error: any) {
    console.log(`Error in fetchStoreReviews: ${error.message}`);
  }
};

export default storeReviews.reducer;
